import React, { useEffect } from 'react';
import getConfig from 'next/config';
import { isEmpty } from 'lodash';
import Router, { withRouter } from 'next/router';
import {
  isMobile, getIsMFALogin,
} from '../utils/browser-utils';
import { useStateValue } from '../state/stateProvider';

const { publicRuntimeConfig: { config } } = getConfig();

const MainPage = ({ router }) => {
  const [{ user }] = useStateValue();

  const navigateToEditor = () => {
    window.location.href = config.EDITOR_URL;
  };

  const onBoardingNotFinished = (userObj) => {
    const fieldsToCheck = ['company', 'companySize', 'jobTitle', 'vertical', 'needs'];
    return fieldsToCheck.some((field) => isEmpty(userObj[field]));
  };

  const navigateToOnboarding = ({
    company, companySize, jobTitle, vertical, needs,
  }) => {
    let page = '';
    if (isEmpty(company) || isEmpty(companySize) || isEmpty(jobTitle)) {
      page = 'company';
    } else if (isEmpty(vertical)) {
      page = 'vertical';
    } else if (isEmpty(needs)) {
      page = 'goals';
    }
    Router.push({ pathname: `/onboarding/${page}` });
  };

  useEffect(() => {
    if (!user) {
      return;
    }

    // in case of use in MFA, a call to "/user" won't get us the user. only the initial post message with creds will.
    // Social signups uses redirect so we have to send the user with the social callback as a qs.
    const isMFAlogin = getIsMFALogin();
    if (isMFAlogin) {
      Router.push({
        pathname: '/auth/mfa/mfa-login',
        query: router.query,
      });
      return;
    }

    if (user === 'error') {
      Router.push({
        pathname: '/auth/login',
        query: router.query,
      });
    } else if (user.isNew || router.query.isNew) {
      Router.push({
        pathname: '/auth/signup-success',
      });
    } else if (!isMobile()) {
      if (onBoardingNotFinished(user)) {
        navigateToOnboarding(user);
      } else {
        navigateToEditor();
      }
    } else {
      Router.push({
        pathname: '/discover',
      });
    }
  }, [user]);

  return <></>;
};

export default withRouter(MainPage);
